import { Button, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import CRUDDataTable from '../../util/CRUDDataTable';
import { BROKER } from '../../util/constant';


// While editing cell value, validate blank string
const preProcessEditCellProps = (params) => {
    const value = String(params.props.value);
    const hasError = !value || value?.trim() === '';
    return { ...params.props, error: hasError };
};

const getColumns = userIds => [
    { field: 'id', headerName: 'ID', width: 30 },
    {
        field: 'broker', headerName: 'Broker', width: 120,
        editable: true,
        type: 'singleSelect',
        valueOptions: Object.keys(BROKER),
        preProcessEditCellProps
    },
    { field: 'clientId', headerName: 'Client ID', width: 130, editable: true, preProcessEditCellProps },
    { field: 'apiKey', headerName: 'API Key', width: 100, editable: true, preProcessEditCellProps },
    {
        field: 'userId', headerName: 'User ID', width: 130, editable: true,
        type: 'singleSelect',
        valueOptions: userIds,
        preProcessEditCellProps
    },
    { field: 'passwordOrToken', headerName: 'Password/Token', width: 100, editable: true, preProcessEditCellProps },
    { field: 'totpKey', headerName: 'TOTP Key', width: 150, editable: true, },
    { field: 'cashCapital', headerName: 'Cash Capital', width: 100, type: 'number', editable: true, },
    { field: 'fnoSubscribed', headerName: 'FNO Subscribed', width: 150, type: 'boolean', editable: true, type: 'boolean' },
    { field: 'userCredentials', headerName: 'User Credentials', width: 180, editable: true, },
    { field: 'isActive', headerName: 'Active', width: 100, type: 'boolean', editable: true, type: 'boolean', preProcessEditCellProps },
    { field: 'loginSession', headerName: 'Login Session', width: 180, editable: true, }
];

const newRowDefaultData = {
    broker: BROKER.ANGEL_ONE,
    fnoSubscribed: false,
    isActive: true,
};

export const UserBrokerAccountManagement = ({ user: loggedInUser, users, setAlert }) => {
    const [userBrokerAccounts, setUserBrokerAccounts] = useState([])

    const fetchUserBrokerAccounts = () => {
        fetch(`/algo-trading/api/admin/user-broker-accounts`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                'Authorization': loggedInUser.credential,
            }
        })
            .then(function (response) {
                response.text().then(r => {
                    if (response.ok) {
                        setUserBrokerAccounts(JSON.parse(r))
                        console.log(JSON.parse(r));
                    } else {
                        console.log('FAIL', r)
                    }
                })
            }, function (error) {
                console.log('ERROR', error.message)
                setAlert({
                    message: 'Error fetching users: ' + error.message,
                    open: true,
                    severity: 'error'
                })
            })
    }

    useEffect(() => {
        fetchUserBrokerAccounts();
    }, [loggedInUser])

    const onAdd = (row) => {
        return onSave(row, 'POST');
    }

    const onUpdate = (row) => {
        return onSave(row, 'PUT');
    }

    const onSave = (row, method) => {
        return fetch(`/algo-trading/api/admin/user-broker-accounts`, {
            method,
            headers: {
                "Content-Type": "application/json",
                'Authorization': loggedInUser?.credential,
            },
            body: JSON.stringify(row)
        }).then(r => {
            fetchUserBrokerAccounts();
            return r;
        }).catch(e => {
            fetchUserBrokerAccounts();
            return e;
        })
    }

    const getUserIds = () => {
        return users?.map(user => user.id) || [];
    }

    return (
        <Grid container>

            <CRUDDataTable
                title='User Broker Accounts'
                initialRows={userBrokerAccounts}
                newRowDefaultData={newRowDefaultData}
                columnsData={getColumns(getUserIds())}
                onAdd={onAdd}
                onUpdate={onUpdate} />
        </Grid>)
}
